import React, { useContext } from 'react';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import SubHeader, {
	SubHeaderLeft,
	SubheaderSeparator,
} from '../../../layout/SubHeader/SubHeader';
import Page from '../../../layout/Page/Page';
import AuthContext from '../../../contexts/authContext';
import { demoPagesMenu } from '../../../menu';
import Announcement from '../../../components/management/announcement/Announcement';
import TodayAbsentCount from './dashboard-component/TodayAbsentCount';
import DepartmentWiseAttendanceSummary from './dashboard-component/DepartmentWiseAttendanceSummary';
import StaffActivity from './dashboard-component/StaffActivity';
import AttendanceNotSubmitted from './dashboard-component/AttendanceNotSubmitted';
import Circular from '../../../components/management/circular-details/Circular';
import StaffPeriodSchedule from './dashboard-component/StaffPeriodSchedule';
import AttendanceDetailsForHod from './dashboard-component/AttendanceDetailsForHod';

const HodDashboard = () => {
	const { userData, userTypeId } = useContext(AuthContext);

	return (
		<PageWrapper title={demoPagesMenu.sales.subMenu.dashboard.text}>
			<SubHeader>
				<SubHeaderLeft>
					<span className='fs-5'>Today Overview </span>
					<SubheaderSeparator />
					<strong className='fs-5'>Hi, <span className='text-primary'>{`${userData.fullname}`}</span> !</strong>
				</SubHeaderLeft>
			</SubHeader>
			<Page container='fluid'>
				{userTypeId == 6 ? (
					<div className='row'>
						<div className='col-xl-12'>
							<Announcement />
						</div>
						<div className='col-xl-12'>
							<TodayAbsentCount />
						</div>
						<div className='col-xl-8'>
							<DepartmentWiseAttendanceSummary />
						</div>
						<div className='col-xl-4'>
							<StaffActivity />
						</div>
						<div className='col-xl-6'>
							<AttendanceNotSubmitted />
						</div>
						<div className='col-xl-6'>
							<Circular />
						</div>
					</div>
				) : (
					<div className='row'>
						<div className='col-xl-12'>
							<Announcement />
						</div>
						<div className='col-xl-9'>
							<StaffPeriodSchedule />
						</div>
						<div className='col-xl-3'>
							<AttendanceDetailsForHod />
						</div>
					</div>
				)}
			</Page>
		</PageWrapper>
	);
};

export default HodDashboard;
